import { ColumnType } from 'antd/lib/table';

type ItemNumber = string | number | undefined;

const getItemNumberColumn = <Row,>(
    getItemNumber: (record: Row) => ItemNumber,
    key = 'goods_item_number'
): ColumnType<Row> => ({
    title: '#',
    key,
    align: 'right',
    width: 1,
    sorter: true,
    render: (_, record) => <span data-testid="item-number-column">{getItemNumber(record)}</span>,
});

export default getItemNumberColumn;
